import { render } from "./card-border-red.vue?vue&type=template&id=5bb67cfd&scoped=true"
import script from "./card-border-red.vue?vue&type=script&lang=js"
export * from "./card-border-red.vue?vue&type=script&lang=js"

import "./card-border-red.vue?vue&type=style&index=0&id=5bb67cfd&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb67cfd"]])

export default __exports__